import Storage from '@/storage'
import Logger from '@/logger'
import { ACTIONS } from '@/store/actions'

/**
 * Responsible from loading stored data into state.
 *
 * @export StateLoader
 * @class StateLoader
 */
export default class StateLoader {

    /**
     * Creates an instance of StateLoader.
     * @param {Object} store The Vuex store.
     * @memberof StateLoader
     */
    constructor(store) {
        this.store = store
    }

    /**
     * Loads state from storage.
     *
     * @param {Object} store The Vuex store.
     * @returns {Promise<Object>} { context: Context, reset: boolean, migrationsApplied: Array } The load respomses.
     * @memberof StateLoader
     */
    async loadAsync() {
        Logger.log('Loading the vuex store with data from local storage...', 'Storage / State')

        try {
            const returnData = await Storage.versioning.updateSchemaAndResetAsync()
            const context = await Storage.context.retrieveAsync()
            returnData.context = context

            const sessionToken = await Storage.session.getTokenAsync()

            if (sessionToken)
                await this.store.dispatch(ACTIONS.setRequestToken, sessionToken)

            Logger.logObject({ ...this.store.state }, 'The vuex state is initialised.', 'State')
            return returnData
        } catch (err) {
            Logger.warn(`Unable to restore state from local storage: ${ err }`, 'Storage / State')
        }
    }
}
